// import {
//   channelScanRecordApi,
//   // userQueryCarModelRecordApi,
// } from "../../apis/public-api.js";
import Api from "../../apis/public-api.js";

// 渠道二维码扫码记录埋点（当前用户浏览时只记录一次，因此将标记存储在sessionStorage中）
// scheme_id  版本标识 query.scheme_id || query.id
// channel_id 渠道id 来源query-c
// customer_id  用户uuid
export const channelScanRecord = async function (params) {
  try {
    // this.$loading.show("加载中...");
    const res = await Api.channelScanRecordApi(params);
    sessionStorage.setItem("onlyScanRecorded", true);
    // this.$loading.hide();
    if (res.code !== 0) {
      console.log("渠道二维码扫码记录埋点失败", res.message);
    }
  } catch (error) {
    // this.$loading.hide();
    console.log("渠道二维码扫码记录埋点失败", error);
  }
};

// 用户查询车型记录(埋点)
export const userQueryCarModelRecord = async function (
  basic_info = {},
  goods_info = {}
) {
  const params = Object.assign({
    ...basic_info,
    ...goods_info,
  });
  try {
    // this.$loading.show("加载中...");
    const res = await Api.userQueryCarModelRecordApi(params);
    // this.$loading.hide();
    if (res.code !== 0) {
      console.log("用户查询车型记录埋点失败", res.message);
    }
  } catch (error) {
    // this.$loading.hide();
    console.log("用户查询车型记录埋点失败", error);
  }
};
